<div class="crm-panel">
  <div class="crm-actions-row">
    <button type="button" class="crm-btn ghost" (click)="openCreateInteraction()" [disabled]="isCreateInteractionOpen">
      + Add Interaction
    </button>

    <button type="button" class="sort-chip" (click)="toggleInteractionSort()">
      Sort: {{ (interactionSortOrder$ | async) === 'desc' ? 'New - Old' : 'Old - New' }}
      <mat-icon>swap_vert</mat-icon>
    </button>
  </div>

  <div class="crm-banner error" *ngIf="interactionsErrorMessage">{{ interactionsErrorMessage }}</div>
  <div class="crm-banner error" *ngIf="interactionAttachmentErrorMessage">{{ interactionAttachmentErrorMessage }}</div>
  <div class="crm-banner info" *ngIf="createInteractionSuccessMessage && !isCreateInteractionOpen">{{ createInteractionSuccessMessage }}</div>

  <form class="crm-form" [formGroup]="createInteractionForm" (ngSubmit)="submitInteraction()" *ngIf="isCreateInteractionOpen">
    <div class="crm-grid-2">
      <mat-form-field appearance="outline" class="crm-field">
        <mat-label>Interaction Type</mat-label>
        <mat-select formControlName="interactionType">
          <mat-option *ngFor="let type of interactionTypeOptions" [value]="type.value">{{ type.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="crm-field">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="interactionDatePicker" formControlName="interactionDate" />
        <mat-datepicker-toggle matSuffix [for]="interactionDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #interactionDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="crm-field">
      <mat-label>Subject</mat-label>
      <input matInput formControlName="interactionSubject" maxlength="200" />
    </mat-form-field>

    <div class="crm-grid-2">
      <mat-form-field appearance="outline" class="crm-field">
        <mat-label>Sentiment</mat-label>
        <mat-select formControlName="interactionSentiment">
          <mat-option [value]="null">None</mat-option>
          <mat-option *ngFor="let sentiment of sentimentOptions" [value]="sentiment.value">{{ sentiment.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="crm-field">
        <mat-label>Meeting Purpose</mat-label>
        <mat-select formControlName="interactionMeetingPurpose" multiple>
          <mat-option *ngFor="let purpose of meetingPurposeOptions" [value]="purpose.value">{{ purpose.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="crm-field crm-editor-field">
      <div class="crm-editor-label">Description</div>
      <app-ckeditor
        [data]="createInteractionForm.get('interactionDescription')?.value || ''"
        [height]="'150px'"
        (contentChanged)="onInteractionDescriptionChanged($event)">
      </app-ckeditor>
    </div>

    <div class="crm-grid-3">
      <mat-form-field appearance="outline" class="crm-field">
        <mat-label>City</mat-label>
        <input matInput formControlName="interactionCity" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="crm-field">
        <mat-label>State / Province</mat-label>
        <input matInput formControlName="interactionStateProvince" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="crm-field">
        <mat-label>Country / Region</mat-label>
        <input matInput formControlName="interactionCountryRegion" />
      </mat-form-field>
    </div>

    <div class="crm-grid-2">
      <mat-form-field appearance="outline" class="crm-field">
        <mat-label>Service Type</mat-label>
        <mat-select formControlName="interactionServiceType" (selectionChange)="onInteractionServiceTypeChange($event.value)">
          <mat-option [value]="null">None</mat-option>
          <mat-option *ngFor="let serviceType of serviceTypeOptions" [value]="serviceType.value">{{ serviceType.label }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="crm-field" *ngIf="hasInteractionServiceTypeSelection()">
        <mat-label>Report Type</mat-label>
        <mat-select formControlName="interactionReportType" multiple>
          <mat-option *ngFor="let reportType of reportTypeOptions" [value]="reportType.value">{{ reportType.label }}</mat-option>
        </mat-select>
        <mat-error *ngIf="createInteractionForm.get('interactionReportType')?.invalid && createInteractionForm.get('interactionReportType')?.touched">
          Report Type is required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="crm-grid-2" *ngIf="hasInteractionServiceTypeSelection()">
      <mat-form-field appearance="outline" class="crm-field">
        <mat-label>Report From</mat-label>
        <input matInput [matDatepicker]="reportFromPicker" formControlName="interactionReportFromDate" />
        <mat-datepicker-toggle matSuffix [for]="reportFromPicker"></mat-datepicker-toggle>
        <mat-datepicker #reportFromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="crm-field">
        <mat-label>Report To</mat-label>
        <input matInput [matDatepicker]="reportToPicker" formControlName="interactionReportToDate" />
        <mat-datepicker-toggle matSuffix [for]="reportToPicker"></mat-datepicker-toggle>
        <mat-datepicker #reportToPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="crm-attachment-row">
      <div class="crm-editor-label">Attachment</div>
      <input #interactionAttachmentInput type="file" class="hidden-input" (change)="onInteractionAttachmentSelected($event)" />
      <div class="attachment-picker-row">
        <button type="button" class="interaction-file-trigger" [disabled]="isSubmittingInteraction" (click)="interactionAttachmentInput.click()">Choose File</button>
        <ng-container *ngIf="selectedInteractionAttachmentName; else noInteractionAttachmentSelected">
          <span class="attachment-name">{{ selectedInteractionAttachmentName }}</span>
          <button
            type="button"
            class="crm-link interaction-attachment-remove"
            [disabled]="isSubmittingInteraction"
            (click)="removeInteractionAttachment(interactionAttachmentInput)">
            Remove
          </button>
        </ng-container>
        <ng-template #noInteractionAttachmentSelected>
          <span class="attachment-name">No file chosen</span>
        </ng-template>
      </div>
      <div class="attachment-help">Max file size: 5MB</div>
    </div>

    <div class="crm-banner error" *ngIf="createInteractionErrorMessage">{{ createInteractionErrorMessage }}</div>

    <div class="crm-form-actions">
      <button type="submit" class="crm-btn" [disabled]="createInteractionForm.invalid || isSubmittingInteraction">
        {{ isSubmittingInteraction ? 'Saving...' : 'Create Interaction' }}
      </button>
      <button type="button" class="crm-btn ghost" (click)="toggleCreateInteraction()">Cancel</button>
    </div>
  </form>

  <div class="crm-banner info" *ngIf="(interactions$ | async)?.length === 0 && hasRequestedInteractions && !(interactionsFetching$ | async)">
    No interactions found for this client selection.
  </div>

  <div class="crm-list" *ngIf="interactions$ | async as interactions">
    <div class="crm-list-item" *ngFor="let interaction of interactions">
      <div class="interaction-card-header">
        <div class="interaction-author-section">
          <div class="interaction-avatar">{{ getInteractionInitials(interaction.ownerName) }}</div>
          <div class="interaction-author-info">
            <div class="interaction-author-name">{{ interaction.ownerName || 'Unknown User' }}</div>
            <div class="interaction-author-date">{{ getInteractionHeaderDate(interaction) }}</div>
          </div>
        </div>
        <div class="interaction-regarding" *ngIf="interaction.regardingName">
          Regarding: {{ interaction.regardingName }}
        </div>
      </div>

      <div class="interaction-title">{{ interaction.subject || 'Untitled interaction' }}</div>

      <div class="interaction-detail" *ngIf="interaction.typeLabel"><strong>Type:</strong> {{ interaction.typeLabel }}</div>
      <div class="interaction-detail" *ngIf="getInteractionDateOnly(interaction)"><strong>Date:</strong> {{ getInteractionDateOnly(interaction) }}</div>
      <div class="interaction-detail" *ngIf="getInteractionMeetingPurposeLabel(interaction)"><strong>Meeting Purpose:</strong> {{ getInteractionMeetingPurposeLabel(interaction) }}</div>
      <div class="interaction-detail" *ngIf="getInteractionServiceTypeLabel(interaction)"><strong>Service Type:</strong> {{ getInteractionServiceTypeLabel(interaction) }}</div>
      <div class="interaction-detail" *ngIf="getInteractionReportTypeLabel(interaction)"><strong>Report Type:</strong> {{ getInteractionReportTypeLabel(interaction) }}</div>
      <div class="interaction-detail" *ngIf="getInteractionReportCoveredLabel(interaction)"><strong>Report Coverage:</strong> {{ getInteractionReportCoveredLabel(interaction) }}</div>

      <div class="interaction-description" *ngIf="hasInteractionDescription(interaction)">
        <div #interactionBodyEl class="item-body" [class.clamped]="!interaction.isExpanded" [innerHTML]="sanitizeInteractionDescription(interaction.description)"></div>
        <button class="see-more-btn" type="button" *ngIf="interaction.showSeeMore || interaction.isExpanded" (click)="toggleInteractionExpand(interaction)">
          {{ interaction.isExpanded ? 'See less' : 'See more' }}
        </button>
      </div>

      <div class="interaction-attachment-row" *ngIf="interaction.attachmentName">
        <mat-icon>attach_file</mat-icon>
        <button
          type="button"
          class="crm-link interaction-attachment-link"
          [disabled]="isDownloadingAttachment$ | async"
          (click)="downloadInteractionAttachment(interaction)">
          {{ interaction.attachmentName }}
        </button>
      </div>
    </div>
  </div>
</div>

